import styled from 'styled-components';
import { ReactComponent as _GlobalLinkIcon } from 'styles/icons/global-link.svg';
import { H2 as GenericH2 } from 'components/typography/style';
import { color, typography } from 'styles/settings';

export const GlobalLinkIcon = styled(_GlobalLinkIcon)`
  margin-right: 15px;
`;

export const Counter = styled.div`
  position: relative;
  top: 1px;
  width: 26px;
  height: 26px;
  border-radius: 100%;
  line-height: 26px;
  text-align: center;
  background-color: ${color.neutral.plainBlack};
  color: ${color.neutral.white};
  ${typography.font.content.semiBold};
  font-size: ${typography.size.md};
  margin-left: 15px;
`;

export const Title = styled(GenericH2)`
  ${typography.font.title.bold};
  font-size: 46px;
  line-height: 81px;
`;

export const Content = styled.div`
  margin: 30px 40px 85px 40px;
  max-height: 660px;
`;

export const NodeContainer = styled.div`
  width: fit-content;
  margin-top: 20px;
  padding: 0 83px;
  padding-bottom: 20px;
`;
